import React, { useRef, useState } from "react"
import styled from "@emotion/styled"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Slider from "react-slick"
import Player from "@vimeo/player"
import ArrowLeftIcon from "../../icons/arrow-left.svg"
// import ChevronRightIcon from "@heroicons/react/solid/ChevronRightIcon"

import { PhotoProvider, PhotoConsumer } from "react-photo-view"
import "react-photo-view/dist/index.css"

import ArrowExpandAll from "@heroicons/react/outline/ArrowsExpandIcon"

import classNames from "classnames"
import PlayIcon from "../../icons/play.svg"

const Gallery = props => {
  const { shopifyMedia, thumbnailImages, ...rest } = props

  const slickSettings = {
    adaptiveHeight: false,
    dots: false,
    arrows: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  }

  const slickSettingsSmallCarousel = {
    adaptiveHeight: false,
    dots: false,
    arrows: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const slider = useRef(null)
  const slider2 = useRef(null)
  const handleIndexChange = index => {
    // keep slick slider in sync with react-photo-view lightbox
    slider?.current?.slickGoTo?.(index)
    // slider2?.current?.slickGoTo?.(index)
    setCurrentSlideIndex(index)
  }

  const handleBeforeChange = (oldIndex, newIndex) => {
    document.querySelectorAll("video").forEach(vid => vid.pause())

    document.querySelectorAll("iframe").forEach(iframe => {
      // const iframeSrc = iframe.src
      // iframe.src = iframeSrc
      if (iframe?.src.includes("vimeo")) {
        const player = new Player(iframe)

        player.pause()
      }
      if (iframe?.src.includes("youtube")) {
        iframe?.contentWindow?.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        )
      }
    })

    if (newIndex !== currentSlideIndex) {
      handleIndexChange(newIndex)
    }
  }

  const handleYoutubeUrl = url => {
    const urlWithEmbed = url.replace("youtu.be", "www.youtube.com/embed")
    return urlWithEmbed
  }

  return (
    <Container {...rest}>
      <PhotoProvider onIndexChange={index => handleIndexChange(index - 1)}>
        <Slider
          ref={slider}
          {...slickSettings}
          beforeChange={handleBeforeChange}
        >
          {shopifyMedia &&
            shopifyMedia.map((item, index) => {
              const imageData = item?.preview?.image?.gatsbyImageData
                ? getImage(item?.preview?.image)
                : item?.preview?.image?.src

              const imageDataWebP =
                imageData?.images?.sources[0].srcSet.split(" ")[0]

              if (!imageData && !imageDataWebP) {
                return null
              }
              const mp4video = item?.sources?.find(
                source => source?.format === "mp4"
              )

              if (!item?.embeddedUrl && imageData && !mp4video) {
                return (
                  <PhotoConsumer
                    key={index}
                    src={
                      imageData?.images?.fallback?.src ||
                      imageDataWebP ||
                      imageData
                    }
                  >
                    <ImageBlock>
                      {imageData?.images ? (
                        <GatsbyImage
                          image={imageData}
                          alt={item?.preview?.image?.altText || ""}
                          loading={index === 0 ? "eager" : "lazy"}
                          className="mx-auto max-h-[486px]"
                          objectFit="contain"
                        />
                      ) : (
                        <img
                          src={imageData}
                          className="mx-auto max-h-[486px]"
                        />
                      )}

                      <ArrowExpandAll />
                    </ImageBlock>
                  </PhotoConsumer>
                )
              } else {
                return (
                  <ImageBlock className="relative">
                    {!item?.embeddedUrl ? (
                      <video
                        title={mp4video?.url}
                        controls
                        id="videos"
                        className="relative z-50"
                      >
                        <source
                          className="aspect-w-16 aspect-h-9 pointer-events-auto relative h-[486px] w-full"
                          src={mp4video?.url}
                        ></source>
                      </video>
                    ) : (
                      <div className=" relative z-50 h-0 w-full pb-[56.25%]">
                        <iframe
                          className="absolute top-0 left-0 mx-auto h-full w-full "
                          allowFullScreen
                          width={560}
                          height={315}
                          src={
                            handleYoutubeUrl(item?.embeddedUrl) +
                            "?enablejsapi=1"
                          }
                        ></iframe>
                      </div>
                    )}
                  </ImageBlock>
                )
              }
            })}
        </Slider>
      </PhotoProvider>

      {thumbnailImages?.length > 1 && (
        <Slider
          className="my-4 mx-auto mt-[35px] max-w-[500px] px-[20px]"
          ref={slider2}
          {...slickSettingsSmallCarousel}
          swipeToSlide={true}
          focusOnSelect={false}
          arrows={true}
          prevArrow={<ArrowLeft />}
          nextArrow={<ArrowRight next />}
        >
          {thumbnailImages?.map?.((item, index) => {
            const imageData = item?.preview?.image?.gatsbyImageData
              ? getImage(item?.preview?.image)
              : item?.preview?.image?.src

            if (imageData) {
              return (
                <div key={index}>
                  <div className="flex justify-center">
                    <button
                      onClick={() => handleIndexChange(index)}
                      className={classNames(
                        "relative h-[84px] w-[84px] cursor-pointer rounded border-solid",
                        currentSlideIndex === index
                          ? "border-2 border-darkBlue"
                          : "border border-grey"
                      )}
                    >
                      {!item?.preview?.image?.src && (
                        <div className="absolute top-0 right-0 z-50 h-[16px] w-[16px] rounded-sm bg-white">
                          <PlayIcon className="ml-[1px] w-[15px]" />
                        </div>
                      )}
                      {imageData?.images ? (
                        <GatsbyImage
                          image={imageData}
                          alt={item?.preview?.image?.altText || ""}
                          className="relative z-40 h-full w-full"
                        />
                      ) : (
                        <img
                          src={imageData}
                          className="mx-auto h-full max-h-[486px] w-full"
                        />
                      )}
                    </button>
                  </div>
                </div>
              )
            } else {
              return null
            }
          })}
        </Slider>
      )}
    </Container>
  )
}

export default Gallery

const Container = styled.div`
  .slick-dots {
    margin: 20px 0;
    position: relative;
    bottom: unset;
  }
  .slick-dots li {
    width: 80px;
    height: 80px;
    opacity: 0.8;
    border: 2px solid transparent;
    &:hover {
      opacity: 1;
    }
    &.slick-active {
      border: 2px solid black;
      opacity: 1;
    }
  }
`

const ImageBlock = styled.div`
  width: 100%;
  cursor: pointer;
  position: relative;

  svg {
    width: 38px;
    height: 38px;
    transition: all 150ms ease-in-out;
    left: calc(50% - 19px);
    top: calc(50% - 19px);
    position: absolute;
    z-index: 2;
    color: white;
    opacity: 0;
  }
  &:hover {
    svg {
      opacity: 1;
    }
    &:before {
      background-image: rgba(0, 0, 0, 0.4);
      opacity: 0.55;
    }
  }
  &:before {
    z-index: 1;
    transition: all 150ms ease-in-out;
    content: "";
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const ArrowLeft = ({ ...rest }) => {
  return (
    <button
      {...rest}
      className="absolute left-0 top-0 bottom-0 z-50 h-full md:left-[-12px] "
    >
      <ArrowLeftIcon className="relative  h-[18px] w-[10px] md:h-[32px]  " />
    </button>
  )
}

const ArrowRight = ({ ...rest }) => {
  return (
    <button
      {...rest}
      className="absolute right-0 top-0 bottom-0 z-50 h-full md:right-[-12px] "
    >
      <ArrowLeftIcon className="relative h-[18px] w-[10px] rotate-180 md:h-[32px] " />
    </button>
  )
}
